module.exports = __webpack_public_path__ + "img/reading4.9ddff049.png";